// extracted by mini-css-extract-plugin
module.exports = {"ComponentBar":"ComponentBar_ComponentBar__1656p"};